import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Row, Container, Button } from "react-bootstrap";
import { motion } from "framer-motion";

function CukPage() {
  const [isVisible, setIsVisible] = useState(false);

  // Effect for animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      const contentSection = document.getElementById('cuk-content');
      if (contentSection) {
        const contentPosition = contentSection.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (contentPosition < windowHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Run once on initial load
    setTimeout(handleScroll, 100);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Array of image objects
  const images = [
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3662.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3762.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3788.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3798.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3799.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3800.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3801.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_3805.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4257.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4140.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4507.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4513.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4516.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4405.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4546.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4560.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4570.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4627.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_5858.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_5822.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_5825.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_4539.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_7199.JPG" },
    { url: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/cuk_2025/IMG_6092.JPG" },
    
   
  ];


  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // Simple custom styles
  const customStyles = `
    .main-container {
      max-height: 100vh;
      overflow: hidden;
      margin: 15px auto;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background-color: #fff;
    }
    
    .content-card {
      height: 100%;
      padding: 15px 20px;
      overflow-y: auto;
      border-right: 1px solid #e9ecef;
    }
    
    .carousel-container {
      height: 80vh;
      padding: 15px;
    }
    
    .carousel-indicators button {
      width: 8px !important;
      height: 8px !important;
      border-radius: 50% !important;
      background-color: #adb5bd !important;
      margin: 0 4px !important;
    }
    
    .carousel-indicators .active {
      background-color: #007bff !important;
    }
    
    .event-title {
      color: #0056b3;
      margin-bottom: 10px;
      font-size: 1.4rem;
      font-weight: 600;
    }
    
    .event-date {
      color: #dc3545;
      font-weight: 600;
      margin-bottom: 10px;
    }
    
    .event-sponsor {
      margin-bottom: 15px;
    }
    
    .divider {
      height: 1px;
      background-color: #e9ecef;
      margin: 15px 0;
    }
    
    .logo-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      margin: 20px 0;
    }

    /* Fix for carousel image sizing */
    .carousel, .carousel-inner, .carousel-item {
      height: 100%;
    }
    
    .carousel-item img {
      height: calc(80vh - 70px);
      object-fit: contain;
      width: 100%;
    }
    
    @media (max-width: 768px) {
      .main-container {
        max-height: none;
      }
      
      .content-card {
        border-right: none;
        border-bottom: 1px solid #e9ecef;
      }
      
      .carousel-container {
        height: 50vh;
      }
      
      .carousel-item img {
        height: calc(50vh - 50px);
      }
    }
  `;

  return (
    <Container fluid className=" my-5 py-4">
      {/* Add custom styles */}
      <style>{customStyles}</style>
      
     

      {/* Main content container */}
      <Container className="main-container py-1 my-1">
 {/* Main heading */}
 <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-1"
      >
        <h2 className="fw-bold display-5 fw-bold">Recent Conference / Events</h2>
        <hr className="mx-auto" style={{ width: "60%", maxWidth: "200px" }}/>
        <p className="fw-bold">Event:- Central University of Karnataka - 2025</p>
      </motion.div>

        <Row className="h-100 g-0">
          {/* Left Content Section */}
          <Col xs={12} md={6} id="cuk-content">
            <motion.div
              className="content-card"
              initial="hidden"
              animate={isVisible ? "visible" : "hidden"}
              variants={staggerContainer}
            >
              <motion.h3 
                className="event-title text-center"
                variants={fadeInUp}
              >
                International Conference on Earth & Environment in Anthropocene - 2025
              </motion.h3>
              
              <motion.p 
                className="event-date text-center"
                variants={fadeInUp}
              >
                March - 2025 
              </motion.p>
              
              <motion.p 
                className="event-sponsor text-primary text-center"
                variants={fadeInUp}
              >
                Proudly Co-Sponsored by OlewinGroup Collaborative with Sponsor of ANRF 
                <Button className="py-2 my-3 btn btn-primary" href="https://dst.gov.in/anusandhan-national-research-foundation-anrf " target="blank"> Visit ANRF Website for More </Button>
              </motion.p>
              <motion.div variants={fadeInUp}>
                <p className="text-center mb-2">
                  In collaboration with Department of Geology, School of Earth Sciences<br/>
                  <strong>Central University of Karnataka</strong>
                </p>
                <p className="text-center mb-0">
                  <strong>Topic:- Quantum Driven - AI in GeoSciences, Future Tech Innovation, Semi-Conductors and Green Energy & Hydrogen (The Future Fuel) </strong>
                </p>
              </motion.div>
              
              <div className="divider"></div>
              
              <motion.div variants={fadeInUp} className="text-center">
                <p className="mb-1">By: <strong>Bandaru Mahesh</strong></p>
                <p className="mb-1"><strong>International Event Sponsor & Core Professor & Founder of Olewin Group</strong></p>
                <p className="mb-3"><strong>IIT Kharagpur & MIT-USA</strong></p>
             
              </motion.div>

              {/* Logos */}
              <motion.div 
              className="d-flex justify-content-center align-items-center mt-3 mb-3"
              variants={fadeInUp}
            >
                <img 
                src="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/olewin2b.png" 
                alt="olewin" 
                className="img-fluid me-4" 
                style={{ width: "150px", maxWidth: "120px" }}
               /> 
               <img 
                src="https://vajiramandravi.com/current-affairs/wp-content/uploads/2025/05/governing_board_meeting_of_the_anusandhan_national_research_foundation_anrf.webp" 
                alt="anrf" 
                className="img-fluid me-4" 
                style={{ width: "150px", maxWidth: "120px" }}
              /> 
              <img 
                src="https://upload.wikimedia.org/wikipedia/en/thumb/a/aa/Central_University_of_Karnataka.svg/1200px-Central_University_of_Karnataka.svg.png" 
                alt="CUK Logo" 
                className="img-fluid mb-3" 
                style={{ height: "80px", width: "80px" }} 
              />
             
            </motion.div>
            
            <motion.p 
              className="text-center mb-0 mt-3"
              variants={fadeInUp}
            >
              </motion.p>
            </motion.div>
          </Col>

          {/* Right Carousel Section */}
          <Col xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7 }}
              className="carousel-container"
            >
              <Carousel 
                interval={2500} 
                indicators={true}
                controls={true}
              >
                {images.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img 
                      className="d-block" 
                      src={item.url} 
                      alt="Conference" 
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default CukPage;